(function () {
  function init(root) {
    var token = root.dataset.token;
    var handle = root.dataset.handle;
    if (!token || !handle) return;
    var apiVersion = root.dataset.apiVersion || '2026-04';
    var language = root.dataset.language || 'EN';
    var country = root.dataset.country || 'SK';
    var base = (root.dataset.rootUrl || '/').replace(/\/+$/, '');
    var moneyFormat = root.dataset.moneyFormat || '{{amount_with_comma_separator}}';
    var fromLabel = root.dataset.fromLabel || 'from';

    function money(amount) {
      var n = Number(amount);
      if (isNaN(n)) return '';
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
        var noDec = key.indexOf('no_decimals') !== -1;
        var comma = key.indexOf('comma_separator') !== -1;
        var apos = key.indexOf('apostrophe_separator') !== -1;
        var v = noDec ? String(Math.round(n)) : n.toFixed(2);
        var parts = v.split('.');
        var group = comma ? '.' : (apos ? "'" : ',');
        var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, group);
        if (noDec) return intPart;
        return intPart + (comma ? ',' : '.') + parts[1];
      });
    }

    function priceEl(p) {
      var range = p.priceRange || {};
      var min = range.minVariantPrice;
      if (!min) return null;
      var max = range.maxVariantPrice;
      var cmp = p.compareAtPriceRange && p.compareAtPriceRange.minVariantPrice;
      var onSale = cmp && Number(cmp.amount) > Number(min.amount);
      var prefix = max && Number(max.amount) > Number(min.amount) ? fromLabel + ' ' : '';
      var wrap = document.createElement('div');
      wrap.className = 'price' + (onSale ? ' price--on-sale' : '');
      var cont = document.createElement('div');
      cont.className = 'price__container';
      var reg = document.createElement('div');
      reg.className = 'price__regular';
      var regSpan = document.createElement('span');
      regSpan.className = 'price-item price-item--regular';
      regSpan.textContent = prefix + money(min.amount);
      reg.appendChild(regSpan);
      cont.appendChild(reg);
      var sale = document.createElement('div');
      sale.className = 'price__sale';
      if (onSale) {
        var s = document.createElement('s');
        s.className = 'price-item price-item--regular';
        s.textContent = money(cmp.amount);
        var sWrap = document.createElement('span');
        sWrap.appendChild(s);
        sale.appendChild(sWrap);
        var sp = document.createElement('span');
        sp.className = 'price-item price-item--sale price-item--last';
        sp.textContent = prefix + money(min.amount);
        sale.appendChild(sp);
      }
      cont.appendChild(sale);
      wrap.appendChild(cont);
      return wrap;
    }

    var fields = 'title handle onlineStoreUrl featuredImage { url(transform: { maxWidth: 500, maxHeight: 500 }) altText } priceRange { minVariantPrice { amount } maxVariantPrice { amount } } compareAtPriceRange { minVariantPrice { amount } }';
    var q =
      'query BundleLinks($handle: String!, $language: LanguageCode!, $country: CountryCode!) ' +
      '@inContext(language: $language, country: $country) { ' +
      '  product(handle: $handle) { ' +
      '    variants(first: 50) { nodes { ' +
      '      components(first: 25) { nodes { quantity productVariant { product { ' + fields + ' } } } } ' +
      '      groupedBy(first: 25) { nodes { product { ' + fields + ' } } } ' +
      '    } } ' +
      '  } ' +
      '} ';

    function dedupe(items) {
      var seen = {}, out = [];
      items.forEach(function (it) {
        var p = it.product;
        if (!p || !p.handle || p.handle === handle) return;
        if (!p.onlineStoreUrl) return;
        if (seen[p.handle]) {
          if (it.quantity > seen[p.handle].quantity) seen[p.handle].quantity = it.quantity;
          return;
        }
        seen[p.handle] = it;
        out.push(it);
      });
      return out;
    }

    function render(groupName, items) {
      var group = root.querySelector('[data-bundle-group="' + groupName + '"]');
      if (!group || !items.length) return false;
      var list = group.querySelector('[data-bundle-list]');
      items.forEach(function (it) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'bundle-links__card';
        a.href = base + '/products/' + it.product.handle;
        var fi = it.product.featuredImage;
        if (fi && fi.url) {
          var im = document.createElement('img');
          im.className = 'bundle-links__img';
          im.src = fi.url;
          im.alt = fi.altText || it.product.title;
          im.loading = 'lazy';
          im.width = 500;
          im.height = 500;
          a.appendChild(im);
        }
        var span = document.createElement('span');
        span.className = 'bundle-links__title';
        span.textContent = it.product.title;
        if (it.quantity > 1) {
          var qty = document.createElement('span');
          qty.className = 'bundle-links__qty';
          qty.textContent = ' (' + it.quantity + ' ks)';
          span.appendChild(qty);
        }
        a.appendChild(span);
        var pr = priceEl(it.product);
        if (pr) a.appendChild(pr);
        li.appendChild(a);
        list.appendChild(li);
      });
      group.hidden = false;
      return true;
    }

    fetch('/api/' + apiVersion + '/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
      body: JSON.stringify({ query: q, variables: { handle: handle, language: language, country: country } })
    })
      .then(function (r) { return r.json(); })
      .then(function (payload) {
        var p = payload && payload.data && payload.data.product;
        if (!p || !p.variants) return;
        var comps = [], parents = [];
        p.variants.nodes.forEach(function (v) {
          if (v.components && v.components.nodes) {
            v.components.nodes.forEach(function (c) {
              if (c.productVariant && c.productVariant.product) {
                comps.push({ product: c.productVariant.product, quantity: c.quantity || 1 });
              }
            });
          }
          if (v.groupedBy && v.groupedBy.nodes) {
            v.groupedBy.nodes.forEach(function (g) {
              if (g.product) parents.push({ product: g.product, quantity: 1 });
            });
          }
        });
        var a = render('components', dedupe(comps));
        var b = render('parents', dedupe(parents));
        if (a || b) root.hidden = false;
      })
      .catch(function () {});
  }

  function boot() {
    document.querySelectorAll('[data-bundle-links]').forEach(function (el) {
      if (el.dataset.bundleReady) return;
      el.dataset.bundleReady = '1';
      init(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
